import React from 'react';
import { Timeline } from '@mantine/core';
import VersionTimelineItem from '@/pages/Editor/components/VersionHistory/VersionHistoryModal/VersionTimelineItem.tsx';
import { AutomationVersionSimple } from '@/types/automations.ts';

type props = {
  versions: AutomationVersionSimple[];
  publishedVersion?: AutomationVersionSimple;
  latestVersion?: AutomationVersionSimple;
};

const PublishedVersionsTimeline = ({ versions, publishedVersion, latestVersion }: props) => {
  return (
    <>
      <Timeline
        bulletSize={24}
        lineWidth={1}
        color="#ECECED"
        active={100}
        styles={{
          itemBullet: { backgroundColor: 'transparent', borderWidth: 0, boxShadow: 'none' },
          root: { marginLeft: '-6px' },
        }}
      >
        {versions.map((version) => (
          <VersionTimelineItem
            key={version.id}
            version={version}
            publishedVersion={publishedVersion}
            latestVersion={latestVersion}
            publishedVersions={true}
          />
        ))}
      </Timeline>
    </>
  );
};

export default PublishedVersionsTimeline;
